import { Button } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import redux from '../../redux';

const sx = () => ({
  '&:hover': {
    backgroundColor: '#B4B7BD',
    color: '#FFF',
  },
  backgroundColor: '#B4B7BD',
  border: '0 none',
  borderRadius: '8px',
  color: '#FFF',
  fontFamily: 'Avenir Next',
  fontSize: 14,
  fontWeight: 600,
  gap: '10px',
  height: 35,
  padding: '8px 16px',
  textTransform: 'none',
});

function CancelButton() {
  const { t } = useTranslation('bulkPauseUnpause');
  const dispatch: typeof redux.store.dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(redux.modal.close());
  };

  return (
    <Button onClick={handleModalClose} sx={sx}>
      {t('cancel')}
    </Button>
  );
}

export default CancelButton;
